import React from 'react';
import { ConfigProvider, Tooltip } from 'antd';
import { color } from '../../resources/color';
import { Icon } from '../../resources/icon';
import { ButtonIconStyle, ButtonStyle } from './styles';
import { MobileOutlined } from '@ant-design/icons';

export const ButtonTheme = (props) => {
  return renderButtonType(props);
};
export const ButtonToolTip = ({ toolTip, children, placement = 'topLeft' }) => {
  return (
    <Tooltip placement={placement} title={toolTip}>
      {children}
    </Tooltip>
  );
};

const renderButtonType = (props) => {
  let { useFor, title } = props;
  let stuff = {
    htmlType: props.htmlType,
    style: { ...props.style },
    ...props,
  };

  switch (useFor) {
    case 'SEARCH':
      title = 'ค้นหา';
      stuff = {
        ...stuff,
        bgcolor: color.black_why,
        icon: <Icon.Search />,
        type: 'primary',
      };
      break;
    case 'EDIT':
      title = 'แก้ไข';
      stuff = {
        ...stuff,
        bgcolor: color.edit,
        icon: <Icon.Edit />,
        type: 'primary',
      };
      break;
    case 'REMOVE':
      title = 'ลบ';
      stuff = {
        ...stuff,
        bgcolor: color.remove,
        icon: <Icon.Remove />,
        type: 'primary',
      };
      break;
    case 'DETAIL':
      stuff = {
        ...stuff,
        icon: <Icon.Detail />,
        bgcolor: color.yellow_why,
        style: stuff.haveStyle
          ? stuff.style
          : {
              backgroundColor: 'white',
              color: stuff.disabled ? '#E0E0E0' : color.yellow_why,
            },
      };
      break;
    case 'EVERNOTE':
      stuff = {
        ...stuff,
        icon: <Icon.Evernote />,
        bgcolor: color.black_why,
        style: stuff.haveStyle
          ? stuff.style
          : {
              backgroundColor: 'white',
              color: stuff.disabled ? '#E0E0E0' : color.black_why,
            },
      };
      break;
    case 'EDIT2':
      stuff = {
        ...stuff,
        bgcolor: color.yellow_why,
        icon: <Icon.Edit2 />,
        style: stuff.haveStyle
          ? stuff.style
          : {
              backgroundColor: 'white',
              color: stuff.disabled ? '#E0E0E0' : color.yellow_why,
            },
      };
      break;
    case 'LINE2':
      stuff = {
        ...stuff,
        bgcolor: color.line,
        icon: <Icon.Line />,
        style: stuff.haveStyle
          ? stuff.style
          : {
              backgroundColor: 'white',
              color: stuff.disabled ? '#E0E0E0' : color.line,
            },
      };
      break;
    case 'DELETE':
      stuff = {
        ...stuff,
        bgcolor: color.black_why,
        icon: <Icon.Remove />,
        style: stuff.haveStyle
          ? stuff.style
          : {
              backgroundColor: 'white',
              color: stuff.disabled ? '#E0E0E0' : color.black_why,
            },
      };
      break;
    case 'VIEW':
      title = title || 'ดูข้อมูล';
      stuff = {
        ...stuff,
        icon: <Icon.View />,
        type: 'primary',
      };
      break;
    case 'TRANSFER':
      title = title || 'โอน';
      stuff = {
        ...stuff,
        icon: <Icon.Transfer />,
        bgcolor: color.yellow_why,
        type: 'primary',
      };
      break;
    case 'CHECK':
      title = 'ตรวจสอบ';
      stuff = {
        ...stuff,
        icon: <Icon.Check />,
        type: 'default',
      };
      break;
    case 'CLEAR':
      title = 'ล้างข้อมูล';
      stuff = {
        ...stuff,
        icon: <Icon.Clear />,
        type: 'default',
      };
      break;
    case 'DOWNLOAD_QR':
      stuff = {
        ...stuff,
        icon: <Icon.Download />,
        bgcolor: color.blue_why,
        style: stuff.haveStyle
          ? stuff.style
          : {
              backgroundColor: 'white',
              color: stuff.disabled ? '#E0E0E0' : color.blue_why,
            },
      };
      break;
    case 'DOWNLOAD':
      title = title || 'ดาว์นโหลด';
      stuff = {
        ...stuff,
        bgcolor: color.black_why,
        icon: <Icon.Download />,
        type: 'primary',
      };
      break;
    case 'PRINT':
      title = title || 'พิมพ์';
      stuff = {
        ...stuff,
        bgcolor: color.remove,
        icon: <Icon.Print />,
        type: 'primary',
      };
      break;
    case 'SUBMIT':
      title = 'บันทึก';
      stuff = {
        ...stuff,
        bgcolor: color.yellow_why,
        icon: <Icon.Save />,
        type: 'primary',
      };
      break;
    case 'CONFIRM':
      title = title || 'ยืนยัน';
      stuff = {
        ...stuff,
        bgcolor: color.submit,
        icon: <Icon.Confirm />,
        type: 'primary',
      };
      break;
    case 'CANCEL':
      title = 'ยกเลิก';
      stuff = {
        ...stuff,
        icon: <Icon.Cancel />,
        type: 'default',
      };
      break;
    case 'LOGIN':
      title = 'เข้าสู่ระบบ';
      stuff = {
        ...stuff,
        icon: <Icon.Login />,
        type: 'primary',
      };
      break;
    case 'LOGOUT':
      stuff = {
        ...stuff,
        bgcolor: color.logout,
        icon: <Icon.Login />,
        type: 'primary',
      };
      break;
    case 'FORGET_PASSWORD':
      title = 'ลืมรหัสผ่าน';
      stuff = {
        ...stuff,
        icon: <Icon.ForgetPassword />,
        type: 'default',
      };
      break;
    case 'BACK':
      title = title || 'ย้อนกลับ';
      stuff = {
        ...stuff,
        icon: <Icon.Back />,
        type: 'default',
      };
      break;
    case 'SWITCH':
      stuff = {
        ...stuff,
        icon: <Icon.Back />,
        type: 'primary',
      };
      break;
    case 'CREATE':
      stuff = {
        ...stuff,
        bgcolor: color.search,
        icon: <Icon.Create />,
        type: 'primary',
      };
      break;
    case 'ZIP_XML':
      stuff = {
        ...stuff,
        icon: <Icon.Download />,
        type: 'primary',
      };
      break;
    case 'RESEND':
      stuff = {
        ...stuff,
        icon: <Icon.ReAct />,
        type: 'default',
      };
      break;
    case 'REQ_PASSWORD':
      stuff = {
        ...stuff,
        icon: <Icon.ForgetPassword />,
        bgcolor: color.search,
        type: 'primary',
      };
      break;
    case 'RE_CHECK':
      stuff = {
        ...stuff,
        icon: <Icon.Recheck />,
        bgcolor: color.edit,
        type: 'primary',
      };
      break;
    case 'REGISTER':
      stuff = {
        ...stuff,
        icon: <Icon.Register />,
        bgcolor: color.submit,
        type: 'primary',
      };
      break;
    case 'WARRANTY':
      title = title || 'ลงทะเบียนสินค้า';
      stuff = {
        ...stuff,
        bgcolor: color.yellow_why,
        icon: <Icon.Register />,
        type: 'primary',
      };
      break;
    case 'CONFIRM_CLAIM':
      title = title || 'อนุมัติเคลม';
      stuff = {
        ...stuff,
        bgcolor: color.black_why,
        icon: <Icon.Register />,
        type: 'primary',
      };
      break;
    case 'BILL':
      title = title || 'ใบส่งสินค้า';
      stuff = {
        ...stuff,
        bgcolor: color.yellow_why,
        icon: <Icon.Register />,
        type: 'primary',
      };
      break;
    case 'REJECT':
      title = 'ไม่อนุมัติ';
      stuff = {
        ...stuff,
        bgcolor: color.edit,
        icon: <Icon.Edit />,
        type: 'primary',
      };
      break;
    case 'CHANGE_PRODUCT':
      title = title || 'เปลี่ยนสินค้า';
      stuff = {
        ...stuff,
        bgcolor: color.black_why,
        icon: <Icon.Change />,
        type: 'primary',
      };
      break;
    case 'CANCEL_LIST':
      title = title || 'ยกเลิกรายการ';
      stuff = {
        ...stuff,
        bgcolor: color.black_why,
        icon: <Icon.Cancel />,
        type: 'primary',
      };
      break;
    case 'BACK_2':
      title = 'ย้อนกลับ';
      stuff = {
        ...stuff,
        icon: <Icon.DoubleLeft />,
        type: 'default',
      };
      break;
    case 'IMPORT':
      title = 'Import File';
      stuff = {
        ...stuff,
        bgcolor: color.black_why,
        icon: <Icon.Import />,
        type: 'primary',
      };
      break;
    case 'DOWNLOADTEM':
      title = 'ตัวอย่างเทมเพลต';
      stuff = {
        ...stuff,
        bgcolor: color.black_why,
        icon: <Icon.Download />,
        type: 'primary',
      };
      break;
    case 'LINE':
      title = title || 'ไลน์';
      stuff = {
        ...stuff,
        icon: <Icon.Line />,
        bgcolor: color.line,
        type: 'primary',
      };
      break;
    case 'TEL':
      title = title || 'เบอร์';
      stuff = {
        ...stuff,
        icon: <MobileOutlined />,
        type: 'primary',
      };
      break;
    case 'REGISTER2':
      stuff = {
        ...stuff,
        icon: <Icon.Register />,
        bgcolor: color.yellow_why,
        type: 'primary',
      };
      break;
    default:
      stuff = {
        ...stuff,
        bgcolor: props.color,
      };
  }

  const { icon, ...rest } = stuff;
  return (
    useFor &&
    !props.hidden && (
      <ConfigProvider
        theme={
          rest.bgcolor && {
            token: {
              colorPrimary: rest.bgcolor,
            },
          }
        }
      >
        <ButtonStyle {...rest} size={rest.size || 'middle'}>
          <div style={{ display: 'flex' }}>
            <div style={{ height: '100%', marginTop: '2px' }}>{icon}</div>
            <div>&nbsp;{title}</div>
          </div>
        </ButtonStyle>
      </ConfigProvider>
    )
  );
};

export const ButtonIconTheme = (props) => {
  return renderButtonIcon(props);
};

const renderButtonIcon = (props) => {
  let { useFor, text } = props;
  let stuff = {
    htmlType: props.htmlType,
    style: { ...props.style },
    ...props,
  };

  switch (useFor) {
    case 'EDIT':
      text = text || 'แก้ไข';
      stuff = {
        ...stuff,
        color: color.edit,
        icon: <Icon.Edit />,
      };
      break;
    case 'REMOVE':
      text = text || 'ลบ';
      stuff = {
        ...stuff,
        color: color.remove,
        icon: <Icon.Remove />,
      };
      break;
    case 'CANCEL':
      text = text || 'ยกเลิก';
      stuff = {
        ...stuff,
        bgcolor: color.remove,
        color: 'white',
        icon: <Icon.Cancel />,
      };
      break;
    case 'SEARCH':
      text = text || 'ค้นหา';
      stuff = {
        ...stuff,
        color: color.search,
        icon: <Icon.Search />,
      };
      break;
    case 'DOWNLOAD':
      text = text || 'ดาว์นโหลด';
      stuff = {
        ...stuff,
        color: color.submit,
        icon: <Icon.Download />,
      };
      break;
    case 'PRINT':
      text = text || 'พิมพ์';
      stuff = {
        ...stuff,
        color: color.remove,
        icon: <Icon.Print />,
      };
      break;
    case 'RESEND':
      stuff = {
        ...stuff,
        color: 'black',
        icon: <Icon.ReAct />,
      };
      break;
    case 'REQ_PASSWORD':
      stuff = {
        ...stuff,
        icon: <Icon.ForgetPassword />,
        color: color.search,
      };
      break;
  }
  const { icon, ...rest } = stuff;
  return (
    useFor && (
      <Tooltip placement="top" title={text}>
        <span style={{ padding: '2px' }}>
          <ButtonIconStyle shape="circle" size={stuff.size || 'middle'} {...rest}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{ height: '100%', marginTop: '2px' }}>{icon}</div>
            </div>
          </ButtonIconStyle>
        </span>
      </Tooltip>
    )
  );
};
